import type { MeterData, RosettaSDK } from "@product/rosetta-sdk";
import type { AsyncState } from "@react-hookz/web";
import { atom } from "jotai";

export type AppSettings = {
  litePaywallTimeFrame?: number;
  oldArticleTimeframe?: number;
};

export type RosettaAtom = {
  appSettings?: AppSettings;
  contentServiceUserInfo?: {
    isSubscriptionEnabled: boolean;
  };
  hasIpAccess?: boolean;
  hasPianoExperienceExecuted?: boolean;
  hasScmpDigitalAccessRight?: boolean;
  hasScmpLiteAccessRight?: boolean;
  hasScmpPlusAccessRight?: boolean;
  instance?: RosettaSDK;
  isScmpPlusSubscriber?: boolean;
  isScmpSubscriber?: boolean;
  meterData?: MeterData;
  tracking?: Rosetta.SDK.RulesEngineTypes.Outcomes["tracking"];
  user?: Rosetta.SDK.RulesEngineTypes.Outcomes["user"];
};

export const rosettaAtom = atom<AsyncState<RosettaAtom | undefined> | undefined>(undefined);
